module.exports = __webpack_public_path__ + "static/media/icon_realise_big_gris.12514633.svg";